import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#FFF",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "m39.53 13.73 2.14 2.141c.97.97.97 2.543 0 3.513l-2.489 2.49c-1.564 1.563-.455 4.239 1.76 4.242h19.798a2.48 2.48 0 0 1 2.484 2.483l.003 6.344a2.484 2.484 0 0 1-2.487 2.486H40.94c-2.214-.002-3.32 2.676-1.756 4.24l2.486 2.486c.97.97.97 2.543 0 3.513l-2.144 2.144c-.97.97-2.543.97-3.513 0L19.73 33.53a2.485 2.485 0 0 1-.003-3.516l16.286-16.286c.97-.97 2.543-.97 3.516.003" }),
      _createElementVNode("path", { d: "M0 32V2.484A2.48 2.48 0 0 1 2.484 0h59.032A2.48 2.48 0 0 1 64 2.484v19.032A2.484 2.484 0 0 1 61.516 24h-3.032A2.484 2.484 0 0 1 56 21.516V10.484A2.48 2.48 0 0 0 53.516 8H10.484A2.48 2.48 0 0 0 8 10.484v43.032A2.48 2.48 0 0 0 10.484 56h43.032A2.48 2.48 0 0 0 56 53.516V42.484A2.484 2.484 0 0 1 58.484 40h3.032A2.484 2.484 0 0 1 64 42.484v19.032A2.48 2.48 0 0 1 61.516 64H2.484A2.48 2.48 0 0 1 0 61.516z" })
    ], -1)
  ]))]))
}
export default { render: render }